import { render, staticRenderFns } from "./FiltroDataRange.vue?vue&type=template&id=1bc472c3&scoped=true&"
import script from "./FiltroDataRange.vue?vue&type=script&lang=js&"
export * from "./FiltroDataRange.vue?vue&type=script&lang=js&"
import style0 from "./FiltroDataRange.vue?vue&type=style&index=0&id=1bc472c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc472c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDatePicker,VMenu,VRangeSlider,VRow,VTextField})
